@if (isBooking()) {
  <div class="flex flex-col items-center justify-center gap-6 py-24">
    <div
      class="h-16 w-16 animate-spin rounded-full border-4 border-t-transparent"
      [ngStyle]="{
        borderColor: corporateDesign.primaryColor(),
        borderTopColor: 'transparent',
      }"></div>
    <p
      class="text-xl font-semibold"
      [ngStyle]="{ color: corporateDesign.primaryColor() }">
      {{
        textStore.texts()
          | filterTexts
            : ERelationType.onDemandBookingLoading
            : EEntityType.onDemandTicketConfiguration
          | language
      }}
    </p>
  </div>
}
<div
  class="flex flex-col items-center gap-6 md:flex-row md:items-start"
  [class.hidden]="isBooking()">
  <div class="flex w-full flex-col gap-4 md:w-2/3">
    <div
      class="rounded-2xl border p-6"
      [ngStyle]="{
        borderColor: corporateDesign.primaryBorderColor(),
        backgroundColor: corporateDesign.surface1(),
        color: corporateDesign.isDarkModeActive()
          ? corporateDesign.corporateDesign().primaryDarkFontColor
          : corporateDesign.corporateDesign().colorAdmixtures
              .standard_text_high,
      }">
      <h2 class="mb-1 text-2xl font-bold">
        {{
          textStore.texts()
            | filterTexts
              : ERelationType.customerData
              : EEntityType.onDemandTicketConfiguration
            | language
        }}
      </h2>
      <p class="mb-5 text-base opacity-60">
        {{
          textStore.texts()
            | filterTexts
              : ERelationType.personalDetails
              : EEntityType.onDemandTicketConfiguration
            | language
        }}
      </p>

      <div class="flex flex-col gap-5" [formGroup]="paymentForm">
        <aw-drop-down
          id="payment-salutation"
          [label]="
            textStore.texts()
              | filterTexts
                : ERelationType.newCustomerSalutation
                : EEntityType.onDemandTicketConfiguration
              | language
          "
          formControlName="salutation"
          [options]="salutationOptions()"
          name="name"
          valueAttribute="id" />

        <aw-text-input
          id="payment-first-name"
          [label]="
            textStore.texts()
              | filterTexts
                : ERelationType.newCustomerFirstName
                : EEntityType.onDemandTicketConfiguration
              | language
          "
          formControlName="firstName" />

        <aw-text-input
          id="payment-last-name"
          [label]="
            textStore.texts()
              | filterTexts
                : ERelationType.newCustomerLastName
                : EEntityType.onDemandTicketConfiguration
              | language
          "
          formControlName="lastName" />

        <aw-date-input
          id="payment-birth-date"
          [label]="
            textStore.texts()
              | filterTexts
                : ERelationType.personalDataBirthdate
                : EEntityType.onDemandTicketConfiguration
              | language
          "
          formControlName="birthDate" />

        <aw-text-input
          id="payment-email"
          [label]="
            textStore.texts()
              | filterTexts
                : ERelationType.email
                : EEntityType.onDemandTicketConfiguration
              | language
          "
          formControlName="email" />

        <aw-text-input
          id="payment-phone"
          [label]="
            textStore.texts()
              | filterTexts
                : ERelationType.newCustomerTelephone
                : EEntityType.onDemandTicketConfiguration
              | language
          "
          formControlName="phone" />

        <aw-checkbox
          id="payment-agreement"
          [label]="
            textStore.texts()
              | filterTexts
                : ERelationType.registryTos
                : EEntityType.onDemandTicketConfiguration
              | language
          "
          formControlName="agreement" />
      </div>
    </div>

    @if (userStore.user()) {
      <div
        class="rounded-2xl border p-6"
        [ngStyle]="{
          borderColor: corporateDesign.primaryBorderColor(),
          backgroundColor: corporateDesign.surface1(),
          color: corporateDesign.isDarkModeActive()
            ? corporateDesign.corporateDesign().primaryDarkFontColor
            : corporateDesign.corporateDesign().colorAdmixtures
                .standard_text_high,
        }">
        <h2 class="mb-5 text-2xl font-bold">
          {{
            textStore.texts()
              | filterTexts
                : ERelationType.onDemandPaymentMethod
                : EEntityType.onDemandTicketConfiguration
              | language
          }}
        </h2>

        @if (isLoadingPaymentMethods()) {
          <aw-loading-animation />
        } @else {
          <div class="flex flex-wrap items-stretch gap-4">
            @if (paymentMethods().length > 0) {
              <aw-single-select
                class="block w-full sm:w-80 [&_label]:min-h-44 [&_label]:items-center"
                id="on-demand-payment-method"
                [hasBorder]="true"
                valueAttribute="id"
                [formControl]="paymentMethodControl"
                [template]="paymentMethodOption"
                [options]="paymentMethods()" />
            }

            <button
              id="on-demand-add-payment-method"
              type="button"
              class="flex min-h-44 w-full cursor-pointer flex-col items-center justify-center gap-2 rounded-lg border bg-transparent p-4 text-center transition-opacity hover:opacity-70 sm:w-80"
              [ngStyle]="{
                borderColor: corporateDesign.primaryBorderColor(),
              }"
              [title]="
                textStore.texts()
                  | filterTexts
                    : ERelationType.onDemandAddPaymentMethod
                    : EEntityType.onDemandTicketConfiguration
                  | language
              "
              [attr.aria-label]="
                textStore.texts()
                  | filterTexts
                    : ERelationType.onDemandAddPaymentMethod
                    : EEntityType.onDemandTicketConfiguration
                  | language
              "
              (click)="addPaymentMethod()">
              <span
                class="material-symbols-rounded"
                style="font-size: 4rem; line-height: 1"
                aria-hidden="true">
                add
              </span>
              <span class="font-semibold">
                {{
                  textStore.texts()
                    | filterTexts
                      : ERelationType.onDemandAddPaymentMethod
                      : EEntityType.onDemandTicketConfiguration
                    | language
                }}
              </span>
            </button>
          </div>
        }
      </div>
    }

    <div class="grid grid-cols-3 gap-4">
      @for (passenger of allPassengersPersonalData(); track $index) {
        <div
          class="flex flex-col gap-1 rounded-2xl border p-5"
          [ngStyle]="{
            borderColor: corporateDesign.primaryBorderColor(),
            backgroundColor: corporateDesign.surface1(),
            color: corporateDesign.isDarkModeActive()
              ? corporateDesign.corporateDesign().primaryDarkFontColor
              : corporateDesign.corporateDesign().colorAdmixtures
                  .standard_text_high,
          }">
          <p class="text-base font-bold">
            {{
              textStore.texts()
                | filterTexts
                  : ERelationType.onDemandTicketNumber
                  : EEntityType.onDemandTicketConfiguration
                | language
            }}
            {{ $index + 1 }}
          </p>
          <p class="text-sm font-semibold opacity-60">
            {{
              selectionState.passengerTicketSelections()[$index]?.fahrgasttyp ??
                EFahrgasttyp.ERWACHSENER
            }}
          </p>
          <p class="mt-2 text-sm opacity-70">
            {{ salutationStore.getTexts(passenger.salutation) | language }}
          </p>
          <p class="text-sm opacity-70">
            {{ passenger.firstName }} {{ passenger.lastName }}
          </p>
          <p class="text-sm opacity-70">{{ passenger.birthDate }}</p>
        </div>
      }
    </div>
  </div>

  <aw-on-demand-ticket-configuration-summary [showReservationDeadline]="true">
    <aw-button
      summary-action
      id="on-demand-payment-next"
      type="button"
      [style]="'error'"
      [isDisabled]="
        paymentForm.invalid ||
        isTransactionInProgress() ||
        (!!userStore.user() && isLoadingPaymentMethods())
      "
      (click)="navigateNext()">
      {{
        textStore.texts()
          | filterTexts
            : ERelationType.onDemandCompleteOrder
            : EEntityType.onDemandTicketConfiguration
          | language
      }}
    </aw-button>
  </aw-on-demand-ticket-configuration-summary>
</div>

<ng-template #paymentMethodOption let-payment="data" let-index="index">
  <aw-payment-method-display
    [id]="'on-demand-payment-method-' + index"
    [paymentMethod]="payment" />
</ng-template>

@if (paymentFailed()) {
  <p class="text-error-main mt-4 text-center">
    {{
      textStore.texts()
        | filterTexts
          : ERelationType.onDemandPaymentFailed
          : EEntityType.onDemandTicketConfiguration
        | language
    }}
  </p>
}
